
<div class="modal-content">
<div class="popup-content-confrm" >
    <div class="modal-body">
    <p class="msg-text">{{ message }}</p>
    </div>
    <button type="button" class="second-button" (click)="confirm()">Yes</button>
    <button type="button" class="cancel-button" (click)="cancel()">Cancel</button>
</div>
</div>
    

  